import { Homepage } from "@main-zone/pages/homepage";

export default Homepage;
